import { Tag } from 'antd';
import { DatabaseOutlined, CloudOutlined, FileTextOutlined, MergeCellsOutlined } from '@ant-design/icons';
interface Props {
  provider: string;
  showIcon?: boolean;
}

const PROVIDER_CONFIG: Record<string, { color: string; label: string; icon: React.ReactNode }> = {
  etilize: {
    color: 'blue',
    label: 'Etilize',
    icon: <DatabaseOutlined />,
  },
  icecat: {
    color: 'cyan',
    label: 'IceCat',
    icon: <CloudOutlined />,
  },
  hp: {
    color: 'geekblue',
    label: 'HP',
    icon: <DatabaseOutlined />,
  },
  external: {
    color: 'purple',
    label: 'External',
    icon: <FileTextOutlined />,
  },
  aggregated: {
    color: 'gold',
    label: 'Aggregated',
    icon: <MergeCellsOutlined />,
  },
  pim: {
    color: 'green',
    label: 'PIM',
    icon: <MergeCellsOutlined />,
  },
};

const DEFAULT_CONFIG = { color: 'orange', label: '', icon: <FileTextOutlined /> };

export function ProviderTag({ provider, showIcon = true }: Props) {
  const config = PROVIDER_CONFIG[provider] || { ...DEFAULT_CONFIG, label: provider };

  return (
    <Tag color={config.color} icon={showIcon ? config.icon : undefined}>
      {config.label}
    </Tag>
  );
}
